/*
 *
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2001 Robert Penner
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
 */
const getUseEasing = (easingType) => {
  switch (easingType) {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    case "easeInExpo": return function (t, b, c, d) {
      return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    }
    case "easeOutExpo": return function (t, b, c, d) {
      return (t == d) ? b + c: c * (-Math.pow(2, -10 * t / d) + 1) + b;
    }
    case "easeInOutExpo": return function (t, b, c, d) {
      if (t == 0) return b;
      if (t == d) return b + c;
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  }
}

export default ( start, end, duration, easingType, callback) => {
  return new Promise((resolve)=>{
    if (start === end) resolve()
    const startTime = Date.now()
    const ease = getUseEasing(easingType)
    requestAnimationFrame(update);
    
    function update(timestamp) {
      const updateTime = Date.now()
      let timeProgress = 0;
      timeProgress = ( updateTime - startTime) / duration;
      timeProgress = Math.min(timeProgress, 1);
      if (timeProgress >= 0) {
        let easeProgress;
        if( start < end ) {
          easeProgress = start + ((end - start) * ease(timeProgress, 0, 1, 1))
        }else{
          easeProgress = start - ((start - end) * ease(timeProgress, 0, 1, 1))
        }
        callback(easeProgress)
      }
      if (timeProgress < 1) {
        requestAnimationFrame(update);
      }else{
        resolve()
      }
    }
  })
}